import { Dispatch, SetStateAction, useState } from "react";
import {
    Modal,
    Button,
    TextField,
    MenuItem,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SendPayout({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [active, setActive] = useState(true);
    const [featured, setFeatured] = useState(false);

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* HEADER */}
                    <div className="modal_title">
                        <h2>Send Payout</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* FORM */}
                    <form className="form">
                        {/* ROW 1 */}
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="payout-amount">Enter Amount</label>
                                <TextField
                                    placeholder="Enter"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "payout-amount" }}
                                />
                            </div>

                        
                          

                            {/* FOOTER */}
                            <div className="footer_btn_flex">
                                <Button
                                    className="btn btn_grey"
                                    onClick={() => setOpen(false)}
                                >
                                   Cancel
                                </Button>
                                <Button
                                    className="btn btn_primary"
                                    onClick={() => setOpen(false)}
                                >
                                    Send
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
